import { EpcProposal } from "graphql-types/graphql";

export type ReductionProposal = EpcProposal & {
    id: string;
    enabled: boolean;
    startYear: number | null;
    epc: string;
    address: string;
    labels: {
        current: string;
        profitable: string;
        possible: string;
    };
};

export const INITIAL_YEAR = 2020;

export type ReductionAnalysisChartData = {
    date: Date;
    int: number | null;
    proj: number | null;
    red: number | null;
};
